<template>
  <v-flex xs12 sm6 md4 lg3>
    <v-card class="text-center ma-3" color="#005A50">
      <v-card-title>
        <v-row align="center" no-gutters>
          <v-col cols="auto">
            <!-- Icon -->
            <!-- <v-icon color="primary">mdi-message-text</v-icon> -->
            <v-btn fab depressed small dark color="#fff">
              <v-icon color="#005A50">mdi-tag-multiple</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <!-- Name -->
            <div align="left" class="ml-2">
              <span class="subtitle-2 font-weight-medium white--text"
                >Current SMS Price</span
              >
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text align="left" class="ml-3">
        <!-- Amount -->
        <div v-if="price" class="text-h6 white--text font-weight-bold">
          Kes {{ price.toFixed(2) }}
        </div>
        <div v-else class="text-h6 white--text font-weight-bold">Kes. 0</div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: ["price"],
};
</script>
